import { apiPost } from "./apiClient";

export const DROPDOWN_SETS = [
  { mode: "engine_layout", label: "Engine layout" },
  { mode: "transmission_type", label: "Transmission type" },
  { mode: "drivetrain", label: "Drivetrain" },
  { mode: "part_side", label: "Part side" },
  { mode: "part_condition_origin", label: "Part condition" },
];
export const DROPDOWN_VALUES_CHANGED = "uzdpart360:dropdown-values-changed";
export const isOptionActive = row => row.status == null || row.status === true || row.status === 1;
export function normalizeDropdownRows(raw) {
  if (!Array.isArray(raw)) throw new Error("Expected an option array. Existing settings were not changed.");
  const ids = new Set();
  let next = Math.max(0, ...raw.map(row => Number.isInteger(row?.id) ? row.id : 0)) + 1;
  return raw.map(row => {
    if (!row || row.value == null || typeof row.label !== "string") throw new Error("Invalid dropdown entry. Existing settings were not changed.");
    const id = row.id == null ? next++ : row.id;
    if (!Number.isSafeInteger(id) || id < 1 || ids.has(id)) throw new Error("Dropdown IDs must be unique positive integers.");
    ids.add(id);
    return { ...row, id, status: isOptionActive(row) ? 1 : 0 };
  });
}
export function dropdownOptions(rows, selected) {
  return rows.filter(row => isOptionActive(row) || String(row.value) === String(selected)).map(row => ({
    value: row.value, label: row.label, disabled: !isOptionActive(row),
  }));
}
export function validateDropdownRows(rows) {
  const normalized = normalizeDropdownRows(rows);
  const values = new Set();
  for (const row of normalized) {
    if (!String(row.value).trim() || !row.label.trim()) throw new Error("Every option needs a value and label.");
    if (values.has(String(row.value))) throw new Error("Option values must be unique, including disabled entries.");
    values.add(String(row.value));
  }
  return normalized;
}
// Semantic fingerprint: property order is immaterial; array order is intentional.
export function dropdownFingerprint(value) {
  if (Array.isArray(value)) return `[${value.map(dropdownFingerprint).join(",")}]`;
  if (value && typeof value === "object") return `{${Object.keys(value).sort().map(key => `${JSON.stringify(key)}:${dropdownFingerprint(value[key])}`).join(",")}}`;
  return JSON.stringify(value);
}
export async function fetchDropdownValues(mode) {
  const response = await apiPost("/whatsapp/get_misc_mode", { mode });
  if (!response.data?.success) throw new Error(response.data?.message || "Unable to load dropdown values.");
  const raw = response.data.data;
  return { raw, rows: normalizeDropdownRows(raw) };
}
export async function saveDropdownValues(mode, rows, baseline) {
  const normalized = validateDropdownRows(rows);
  const latest = await fetchDropdownValues(mode);
  if (dropdownFingerprint(latest.raw) !== dropdownFingerprint(baseline)) throw new Error("These values changed elsewhere. Reload and review before saving.");
  const response = await apiPost("/whatsapp/save_misc_mode", { mode, moredetails: normalized });
  if (!response.data?.success) throw new Error(response.data?.message || "Unable to save dropdown values.");
  window.dispatchEvent(new CustomEvent(DROPDOWN_VALUES_CHANGED, { detail: { mode } }));
  return { raw: normalized, rows: normalized };
}
